<template>
  <div class="label">
    <div class="label__item" :style="{color: textColor}" v-if="earlyCheckIn">
      <ClockIcon :color="textColor"/>
      <span class="label__text">Early Check-In:
        <span class="label__time">
          {{convertStringTimeToHumanFormat(earlyCheckIn.time)}}
        </span>
      </span>
    </div>
    <div class="label__item" :style="{color: textColor}" v-if="lateCheckOut">
      <ClockIcon :color="textColor"/>
      <span class="label__text">Late Check-Out:
      <span class="label__time">
        {{convertStringTimeToHumanFormat(lateCheckOut.time)}}
      </span>
    </span>
    </div>

  </div>
</template>

<script>
import ClockIcon from "@/components/HotelCheckInOutTime/icons/ClockIcon";
export default {
  components: {
    ClockIcon
  },
  name: "HotelCheckInOutTimeLabel",
  props: {
    earlyCheckIn: {
      required: true
    },
    lateCheckOut: {
      required: true
    },
    textColor: {
      type: String,
      default: '#0052B4'
    },
  },
  methods: {
    convertStringTimeToHumanFormat(time) {
      if (time.length === 4) {
        return `${time[0]}${time[1]}:${time[2]}${time[3]}`;
      } else {
        return time;
      }
    }
  }
}
</script>

<style scoped lang="scss">
.label {
  display: flex;
  margin: 1rem 0 0 0;
  color: #0052B4;
  font-size: 12px;
  line-height: 100%;

  &__item {
    display: flex;
    align-items: center;

    &:not(:first-child) {
      margin-left: 1.5rem;
    }
  }

  &__text {
    line-height: 16px;
  }

  &__time {
    font-weight: 500;
  }

  &__icon {
    margin-right: 0.375rem;
  }
}
</style>